import * as Utils from '@js/modules/utils';
import I18n from '@js/modules/translations';

import api from '@js/actions/api';

import MapInterface from '@js/modules/maps/mapInterface';


const RidePoisMapModule = {
    _poiModel: {
        isRide: false,

        // Poi data by ride ids
        poiData: {},
        poiFeatures: {},
        poiMarkersPoints: [],

        // Trigger when poi are loaded
        poiLoadedCallback: [],

        // Trigger when poi image is clicked on map
        poiImageClicked: [],

        poiPictureButtonId: 'ride-poi-picture'
    },

    fetchRidePOIs(rideId) {
        if (rideId && rideId !== 'new') {
            this._poiModel.isRide = true;
        }

        const params = {
            map: {}
        };

        api.get(`/api/v1/rides/${rideId}/points-of-interest`, params, {
            priorityLow: true
        })
            .then((poiData) => {
                if (!poiData || Utils.isEmpty(poiData.pois)) {
                    return;
                }

                this._poiModel.poiData[rideId] = poiData.pois;

                const rideIds = this._mapModel.ridesData?.map((ride) => ride.rideId);
                if (!this._mapModel.ridesData || (Utils.isPresent(rideIds) && rideIds.includes(rideId))) {
                    this._buildPois(rideId);

                    this._drawRidePois(rideId);

                    this._poiLoadedFuncs(rideId, this._poiModel.poiData[rideId]);
                }
            });

        this._addPoiPopupMarkerEvents();
    },

    addRidePoi(poiParams, rideId = 'new', options = {}) {
        if (!poiParams) {
            return;
        }

        return api.post('/api/v1/points-of-interest', {poi: poiParams})
            .then((poiData) => {
                if (!poiData || Utils.isEmpty(poiData.poi)) {
                    return;
                }

                this._poiModel.poiData[rideId] ||= [];
                this._poiModel.poiData[rideId].push(poiData.poi);

                this._buildPois(rideId);

                this._drawRidePois(rideId);

                if (options.centerMap) {
                    this._model.mapBounds = null;
                    this._fitMapBounds({withPois: true});
                }

                return poiData.poi;
            });

        // OPTIMIZE: for poi mode
        // if (this._model.poiModeEnabled) {
        //     let number = 1;
        //
        //     for (let i = 0; i < this._model.poiPointMarkers.length; i++) {
        //         if (this._model.poiPointMarkers[i].type === 'poiGlobal') {
        //             continue;
        //         }
        //
        //         const markerNumber = this._model.poiPointMarkers[i].data.number;
        //         if (markerNumber && markerNumber >= number) {
        //             number = markerNumber + 1;
        //         }
        //     }
        //
        //         this._addPoiMarkerToMap({number: number}, coordinates);
        //
        //     return;
        // }
    },

    updateRidePoi(poiId, poiParams, rideId = 'new') {
        return api.update(`/api/v1/points-of-interest/${poiId}`, {poi: poiParams})
            .then((updatedPoi) => {
                if (!updatedPoi || Utils.isEmpty(updatedPoi.poi)) {
                    return;
                }

                this._poiModel.poiData[rideId] = this._poiModel.poiData[rideId].replaceOrAdd('id', updatedPoi.poi);

                this.clearRidePoiMarkersPoints();

                this._buildPois(rideId);

                this._drawRidePois(rideId);

                return updatedPoi.poi;
            });
    },

    removeRidePoi(poiId, rideId = 'new') {
        return api.delete(`/api/v1/points-of-interest/${poiId}`)
            .then(() => {
                this._poiModel.poiData[rideId] = this._poiModel.poiData[rideId].filter((poiData) => poiData.id !== poiId);

                this.clearRidePoiMarkersPoints();

                this._buildPois(rideId);

                this._drawRidePois(rideId);

                return poiId;
            });
    },

    fitRidePoisBounds(bounds) {
        if (this._poiModel.poiMarkersPoints.length > 0) {
            for (let p = 0; p < this._poiModel.poiMarkersPoints.length; p++) {
                bounds = bounds.extend(this._poiModel.poiMarkersPoints[p].marker.getLngLat());
            }
        }
    },

    clearRidePoiMarkersPoints() {
        if (!this._model.map) {
            return;
        }

        for (let i = 0; i < this._poiModel.poiMarkersPoints.length; i++) {
            this._poiModel.poiMarkersPoints[i].marker.remove();
        }
        this._poiModel.poiMarkersPoints = [];
    },

    /* Private Methods
    ******************** */
    _buildPois(rideId) {
        if (!this._poiModel.poiFeatures[rideId]) {
            this._poiModel.poiFeatures[rideId] = {};
        }

        this._poiModel.poiFeatures[rideId].markerInfos = [];

        for (let poiMarkerIndex = 0; poiMarkerIndex < this._poiModel.poiData[rideId].length; poiMarkerIndex++) {
            if (this._poiModel.poiData[rideId][poiMarkerIndex].type === 'PoiPoint') {
                const poiCoordinates = {
                    lat: this._poiModel.poiData[rideId][poiMarkerIndex].latitude,
                    lng: this._poiModel.poiData[rideId][poiMarkerIndex].longitude
                };

                const poiMarkerInfo = new MapInterface.MarkerInfo(
                    poiCoordinates,
                    'poi',
                    this._poiModel.poiData[rideId][poiMarkerIndex]
                );

                this._poiModel.poiFeatures[rideId].markerInfos.push(poiMarkerInfo);
            }
        }
    },

    _drawRidePois(rideId) {
        if (!rideId || !this._poiModel.poiFeatures[rideId]) {
            return;
        }

        const poiMarkerInfos = this._poiModel.poiFeatures[rideId].markerInfos;
        let poiMarkerInfo;

        // Clear old POI markers
        this._removePoiMarkersPoints(rideId);

        // Draw POI markers
        if (poiMarkerInfos.length > 0) {
            for (let poiMarkerIndex = 0; poiMarkerIndex < poiMarkerInfos.length; poiMarkerIndex++) {
                poiMarkerInfo = poiMarkerInfos[poiMarkerIndex];

                const poiCoordinates = {
                    lat: poiMarkerInfo.latLng.lat,
                    lng: poiMarkerInfo.latLng.lng
                };

                // add popup
                const poiPopup = this.buildPopup({
                    offset: [0, -30]
                })
                    .setHTML(this._buildPoiMarkerPopup(rideId, poiMarkerIndex, poiMarkerInfo));

                const newPoiMarkerPoint = new MapInterface.MarkerPoint(
                    this.buildMarker(
                        'poi-marker',
                        poiCoordinates,
                        {
                            draggable: !this._poiModel.isRide,
                            markerOpacity: this._poiModel.isRide ? '0.6' : undefined,
                            anchor: 'top'
                        }),
                    poiMarkerInfo.data && poiMarkerInfo.data.id,
                    poiPopup
                );

                newPoiMarkerPoint.marker
                    .setPopup(newPoiMarkerPoint.popup);

                // add to map
                newPoiMarkerPoint.marker.addTo(this._model.map);

                // add to array for reference
                this._poiModel.poiMarkersPoints.push(newPoiMarkerPoint);

                // set up event handlers
                this._addPoiMarkersPointEventHandlers(newPoiMarkerPoint, poiMarkerInfo, poiMarkerIndex);
            }
        }
    },

    _addPoiMarkersPointEventHandlers(markerPoint, markerInfo) {
        markerPoint.marker.getElement()
            .addEventListener('click', function (poiPoint, poiInfo, event) {
                event.stopPropagation();

                if (window.innerWidth > window.settings.medium_screen) {
                    return;
                }

                if (this._model.hasPopup) {
                    return;
                }

                //         this._model.hasPopup = true;
                //
                //         this._model.openPopups.push(poiPoint.popup);

                poiPoint.marker.togglePopup();
                this._model.hasPopup = true;
            }.bind(this, markerPoint, markerInfo));

        markerPoint.marker.getElement()
            .addEventListener('mouseenter', function (poiPoint, poiInfo) {
                poiPoint.marker.togglePopup();
                this._model.hasPopup = true;
            }.bind(this, markerPoint, markerInfo));

        markerPoint.marker.getElement()
            .addEventListener('mouseleave', function (poiPoint, poiInfo) {
                poiPoint.marker.togglePopup();
                this._model.hasPopup = false;
            }.bind(this, markerPoint, markerInfo));

        markerPoint.marker
            // .on('dragstart', () => {
            //     // OPTIMIZE: manage undo
            //     // this._pushUndoSnapShot();
            // })
            .on('dragend', function (poiPoint, poiInfo) {
                const newCoordinates = poiPoint.marker.getLngLat();
                const poi = poiInfo.data;

                this.updateRidePoi(poi.id, {
                    latitude: newCoordinates.lat,
                    longitude: newCoordinates.lng
                });
            }.bind(this, markerPoint, markerInfo));
    },

    _buildPoiMarkerPopup(rideId, poiMarkerIndex, poiMarkerInfo) {
        const poiMarkerData = poiMarkerInfo.data;

        const popupContent = document.createElement('div');
        popupContent.className = 'slideshow-popup';

        if (poiMarkerData.pictures.length > 0) {
            const slideShowContent = document.createElement('div');
            for (let pictureIndex = 0; pictureIndex < poiMarkerData.pictures.length; pictureIndex++) {
                const picture = poiMarkerData.pictures[pictureIndex];

                if (picture.mediumUrls && picture.mediumUrls.jpg) {
                    const imageContainer = document.createElement('div');
                    imageContainer.className = 'image';
                    if (pictureIndex === 0) {
                        imageContainer.className += ' active';
                    }

                    const imageContent = document.createElement('img');
                    imageContent.id = this._poiModel.poiPictureButtonId;
                    imageContent.src = picture.mediumUrls.jpg;
                    imageContent.dataset.rideId = rideId;
                    imageContent.dataset.poiMarkerIndex = poiMarkerIndex;
                    imageContent.setAttribute('data-ride-id', rideId);
                    imageContent.setAttribute('data-poi-id', poiMarkerData.id);
                    imageContent.setAttribute('data-poi-index', poiMarkerIndex);
                    imageContent.setAttribute('data-poi-picture-index', pictureIndex);

                    imageContainer.appendChild(imageContent);
                    slideShowContent.appendChild(imageContainer);
                }
            }

            const slideShow = document.createElement('div');
            slideShow.className = 'slideshow';
            slideShow.appendChild(slideShowContent);
            popupContent.appendChild(slideShow);

            if (poiMarkerData.pictures.length > 1) {
                const slideShowNavigation = document.createElement('div');
                slideShowNavigation.className = 'cycle';
                slideShowNavigation.innerHTML =
                    '<a href="#" class="prev">' + I18n.t('js.maps.slideshow.previous') + '</a>' +
                    '<a href="#" class="next">' + I18n.t('js.maps.slideshow.next') + '</a>';
                slideShowNavigation.onclick = function (currentSlideShow, event) {
                    event.preventDefault();

                    let $newSlide;

                    if (this.classList.contains('prev')) {
                        $newSlide = Utils.getPreviousElement(currentSlideShow.querySelector('.active'));
                        if ($newSlide.index() < 0) {
                            $newSlide = currentSlideShow.querySelectorAll('.image')
                                .last();
                        }
                    } else {
                        $newSlide = Utils.getNextElement(currentSlideShow.querySelector('.active'));
                        if ($newSlide.index() < 0) {
                            $newSlide = currentSlideShow.querySelectorAll('.image')
                                .first();
                        }
                    }

                    currentSlideShow.querySelector('.active')
                        .classList
                        .remove('active');
                    currentSlideShow.querySelector('.active').style.display = 'none';

                    $newSlide.classList.add('active');
                    $newSlide.style.display = 'block';

                    return false;
                }.bind(this, slideShow);
                popupContent.appendChild(slideShowNavigation);
            }
        }

        if (poiMarkerData.title || (poiMarkerData.description && poiMarkerData.pictures.length > 0)) {
            const title = document.createElement('p');
            title.className = 'poi-title';
            title.innerHTML = poiMarkerData.title;
            popupContent.appendChild(title);
        }

        if (poiMarkerData.description) {
            if (poiMarkerData.pictures.length === 0) {
                const description = document.createElement('div');
                description.className = 'poi-description';
                description.innerHTML = poiMarkerData.description;
                popupContent.appendChild(description);
            } else {
                // OPTIMIZE: remove material icon
                const moreDescription = document.createElement('i');
                moreDescription.className = 'material-icons poi-description-more';
                moreDescription.innerHTML = 'add_circle';
                moreDescription.onclick = function (currentPoiMarkerData) {
                    window.open(currentPoiMarkerData.link, '_self');
                }.bind(this, poiMarkerData);
                title.appendChild(moreDescription);
            }
        }

        const popupContainer = document.createElement('div');
        popupContainer.className = poiMarkerInfo.type + '-popup'; // poi-popup
        popupContainer.appendChild(popupContent);

        return popupContainer.outerHTML;
    },

    _addPoiPopupMarkerEvents() {
        this._model.$mapId.addEventListener('click', (event) => {
            if (!event.target) {
                return;
            }

            if (event.target.matches('#' + this._poiModel.poiPictureButtonId)) {
                const rideId = parseInt(event.target.getAttribute('data-ride-id'));
                const poiMarkerIndex = parseInt(event.target.getAttribute('data-poi-marker-index'));
                if (rideId && poiMarkerIndex) {
                    this._handlePoiImageClick(rideId, poiMarkerIndex);
                }
            }
        });
    },

    _handlePoiImageClick(rideId, poiMarkerIndex) {
        this.leaveFullscreen();

        this._poiImageClickedFuncs(this._poiModel.poiFeatures[rideId].markerInfos[poiMarkerIndex].data, 0);
    },

    _poiImageClickedFuncs(poiData, pictureIndex) {
        for (let i = 0, n = this._poiModel.poiImageClicked.length; i < n; i++) {
            this._poiModel.poiImageClicked[i](poiData, pictureIndex);
        }
    },

    _poiLoadedFuncs(rideId, poisData) {
        for (let i = 0, n = this._poiModel.poiLoadedCallback.length; i < n; i++) {
            this._poiModel.poiLoadedCallback[i](rideId, poisData);
        }
    },

    // Undo
    // _pushUndoSnapShot() {
    //     const markers = [];
    //     for (i = 0; i < this._mapModel.markersInfo.length; i++) {
    //         const markersInfo = this._mapModel.markersInfo[i];
    //         markers.push(new MapInterface.MarkerInfo(markersInfo.latLng, markersInfo.type, markersInfo.data));
    //     }
    //     this._mapModel.markerStack.push(markers);
    // },

    // _revertToSnapshot(snapShotIndex) {
    //     if (typeof snapShotIndex === 'undefined' || snapShotIndex === null) {
    //         snapShotIndex = this._mapModel.markerStack.length - 1;
    //     }
    //
    //     if (snapShotIndex < 0) {
    //         return;
    //     }
    //
    //     const newMarkersInfo = this._mapModel.markerStack[snapShotIndex];
    //
    //     const diffMarkersInfo = this._mapModel.markersInfo.filter((markerInfo) => {
    //         return !newMarkersInfo.some((newMarkerInfo) => newMarkerInfo['latLng'] === markerInfo['latLng']);
    //     });
    //
    //     this._mapModel.markersInfo = newMarkersInfo;
    //
    //     numberToPop = this._mapModel.markerStack.length - snapShotIndex;
    //     for (i = 0; i < numberToPop; i++) {
    //         this._mapModel.markerStack.pop();
    //     }
    //
    //     diffMarkersInfo.forEach((markerInfo) => {
    //         if (markerInfo.type === 'poi') {
    //             this._mapModel.poiPointMarkers = this._mapModel.poiPointMarkers.filter((poiPointMarker) => poiPointMarker.data.id !== markerInfo.data.id);
    //
    //             this._poiChangedFuncs('delete', markerInfo);
    //         }
    //     });
    //
    //     this._drawMarkersPoints();
    //     this._updateMarkerPoints();
    //     this._markerChangedFuncs();
    // },

    _removePoiMarkersPoints(rideId) {
        if (!!rideId && !!this._poiModel.poiFeatures[rideId]) {
            this.resetMapSource('poi-marker');
        }
    }
};

export default RidePoisMapModule;
